// react
import React from "react";

// components
import { Avatar } from "@performyard/py-components";

import PropTypes from "../../../../lib/prop-types";

const GoalComponent = (props) => {
	const { id, assigneeID, assigneeName } = props;

	return (
		<a href={`/goal/${id}/`} className="goal-container">
			<div className="goal-assignee">
				<Avatar id={assigneeID} size={28} name={assigneeName} />
				{assigneeName}
			</div>
		</a>
	);
};

GoalComponent.propTypes = {
	id: PropTypes.string.isRequired,
	assigneeID: PropTypes.string.isRequired,
	assigneeName: PropTypes.string.isRequired,
};

export default GoalComponent;
